import cookie from 'js-cookie';
import request from 'superagent';

const BANNER_SELECTOR = '.js-slx-region-suggestion-banner';
const CLOSE_BUTTON_SELECTOR = '.js-slx-close-banner-button';
const ACTION_BUTTON_SELECTOR = 'button[data-layout-trigger="regions"]';
const ACTIVE_CLASS_NAME = 'slx-banner--active';
const DOCUMENT_MODIFIER_CLASS_NAME = 'slx--region-suggestion-banner';

const COOKIE_EXPIRE_DAYS = 1;
const COOKIE_NAME = 'slxcom-rbr';
const COOKIE_VALUE = '1';

function plugin(bannerElement) {
	document.documentElement.classList.add(DOCUMENT_MODIFIER_CLASS_NAME);
	bannerElement.classList.add(ACTIVE_CLASS_NAME);

	function remove() {
		cookie.set(COOKIE_NAME, COOKIE_VALUE, {expires: COOKIE_EXPIRE_DAYS});
		document.documentElement.classList.remove(DOCUMENT_MODIFIER_CLASS_NAME);
		bannerElement.classList.remove(ACTIVE_CLASS_NAME);
	}

	const closeButtons = bannerElement.querySelectorAll(CLOSE_BUTTON_SELECTOR);
	for (const button of closeButtons) {
		button.addEventListener('click', remove);
	}

	const actionButtons = bannerElement.querySelectorAll(ACTION_BUTTON_SELECTOR);
	for (const button of actionButtons) {
		button.addEventListener('click', remove);
	}
}

function run() {
	const banners = document.querySelectorAll(BANNER_SELECTOR);
	for (const banner of banners) {
		plugin(banner);
	}
}

let doShowBanner = cookie.get(COOKIE_NAME) !== COOKIE_VALUE;
if (doShowBanner) {
	const currentRegionCode = window.location.pathname.slice(1, 4);

	request
		.get('/int/en/detect-regioncode')
		.set('Accept', 'application/json')
		.query()
		.end((error, response) => {
			if (error) {
				return;
			}

			if (response.body && currentRegionCode !== response.body) {
				run();
			}
		});
}
